<section class="main-top-bar" dir="{{languageDir}}">
  <div class="top-bar-left">
    <button class="navbar-toggler-mob" mat-icon-button [attr.aria-label]="langObj?.MobileMenuOpener ?? ('MobileMenuOpener' | translate)" (click)="mobMenuToggler()">
      <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="6.6416" width="22" height="2.12842" fill="#0F0FD1" />
        <rect y="0.256836" width="18" height="2.12842" fill="#0F0FD1" />
        <rect y="13.0273" width="14" height="2.12842" fill="#0F0FD1" />
      </svg>
    </button>
    <a class="top-bar-logo" [class]="this.translate.currentLang === 'ar' ? 'rtl-logo-css' : ''" (click)="ReturnHome(1)"
      *ngIf="!isMenuOpen">
      <img style="width: 8rem;" src="assets/images/O3sigma_logo_blue.png" alt="O3 Smart Manufacturing">
    </a>
    <button class="search-form-btn-mob" mat-icon-button [attr.aria-label]="langObj?.ToggleSearchForm ?? ('ToggleSearchForm' | translate)" (click)="toggleSearchForm()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.3609 18.2168L14.6008 13.2662C15.8247 11.8113 16.4953 9.98069 16.4953 8.07499C16.4953 3.62251 12.8728 0 8.4203 0C3.96782 0 0.345306 3.62251 0.345306 8.07499C0.345306 12.5275 3.96782 16.15 8.4203 16.15C10.0918 16.15 11.6847 15.6458 13.0466 14.6888L17.8428 19.677C18.0432 19.8852 18.3129 20 18.6018 20C18.8753 20 19.1348 19.8957 19.3317 19.7061C19.7502 19.3034 19.7636 18.6357 19.3609 18.2168ZM8.4203 2.10652C11.7114 2.10652 14.3888 4.78391 14.3888 8.07499C14.3888 11.3661 11.7114 14.0435 8.4203 14.0435C5.12921 14.0435 2.45183 11.3661 2.45183 8.07499C2.45183 4.78391 5.12921 2.10652 8.4203 2.10652Z"
          fill="#10123D" />
      </svg>
    </button>
    <form class="search-form" (ngSubmit)="onSubmit()" [class.active]="isSarchFormVisible">
      <button class="search-btn" mat-icon-button aria-label="">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.6166 10.9301L8.76059 7.95969C9.49492 7.08675 9.89727 5.98841 9.89727 4.845C9.89727 2.17351 7.72376 0 5.05227 0C2.38078 0 0.207275 2.17351 0.207275 4.845C0.207275 7.51648 2.38078 9.68999 5.05227 9.68999C6.05519 9.68999 7.01091 9.38749 7.82803 8.81326L10.7057 11.8062C10.826 11.9311 10.9878 12 11.1612 12C11.3253 12 11.4809 11.9374 11.5991 11.8237C11.8502 11.5821 11.8582 11.1814 11.6166 10.9301ZM5.05227 1.26391C7.02692 1.26391 8.63336 2.87034 8.63336 4.845C8.63336 6.81965 7.02692 8.42608 5.05227 8.42608C3.07762 8.42608 1.47119 6.81965 1.47119 4.845C1.47119 2.87034 3.07762 1.26391 5.05227 1.26391Z"
            fill="#A3B0CE" />
        </svg>
      </button>
      <input type="text" class="form-control"
        [placeholder]="langObj?.NavbarSearchPlaceHolder ?? ('NavbarSearchPlaceHolder' | translate)"
        [formControl]="searchValue" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions | async" (onSelectionChange)="changeValue(option)"
          [value]="option.Text">
          {{option.Text}}
        </mat-option>
      </mat-autocomplete>
    </form>
  </div>
  <div class="top-bar-right">
    <div class="info-wrapper" style="margin-top: 15px; margin-right: 5px;">
      <mat-form-field appearance="outline">
        <mat-label>{{langObj?.Group ?? ('Group' | translate)}}</mat-label>
        <input matInput placeholder="Placeholder" [(ngModel)]="groupName" readonly>
      </mat-form-field>
    </div>

    <div class="info-wrapper" style="margin-top: 15px; margin-right: 5px;">
      <mat-form-field appearance="outline" style="width: 150px;">
        <mat-label>{{langObj?.Plant ?? ('Plant' | translate)}}</mat-label>
        <input matInput placeholder="Placeholder" [(ngModel)]="plantName" readonly>
      </mat-form-field>
    </div>
    <!-- <mat-icon class="o3Color-icon" matTooltip="O3 Help ?" (click)="openPopupO3GPT()">question_answer</mat-icon> -->
    <img src="{{imageSrc}}" class="lang-wh" alt="image">
    <form [formGroup]="translateForm">

      <mat-select class="form-control-lang" style="width: 65px;" #selectedLang formControlName="languagvalue"
        (selectionChange)="translater.switchLang(selectedLang.value);changeLang(selectedLang.value)">

        <mat-option *ngFor="let language of translater.translate.getLangs()" [value]="language">
          <img *ngIf="language === 'en'" src="/assets/images/english.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'ar'" src="/assets/images/arabic.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'fr'" src="/assets/images/french.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'sp'" src="/assets/images/spanish.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'gr'" src="/assets/images/german.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'du'" src="/assets/images/dutch.png" class="lang-wh" alt="image">
          {{ language | uppercase }}
        </mat-option>
      </mat-select>

      <!-- <mat-select class="form-control-lang" style="width: 65px;" #selectedLang formControlName="languagvalue"
        (selectionChange)="translater.switchLang(selectedLang.value);changeLang(selectedLang.value)">

        <mat-option *ngFor="let language of translater.translate.getLangs()" [value]="curent">
          <img *ngIf="language === 'en'" src="/assets/images/english.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'ar'" src="/assets/images/arabic.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'fr'" src="/assets/images/french.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'sp'" src="/assets/images/spanish.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'gr'" src="/assets/images/german.png" class="lang-wh" alt="image">
          <img *ngIf="language === 'du'" src="/assets/images/dutch.png" class="lang-wh" alt="image">
          {{ language | uppercase }}
        </mat-option>
      </mat-select> -->
    </form>
    <button class="notification-btn" (click)="showNotificationBar()" mat-icon-button aria-label=""
      [ngClass]="{'has-notification': notifcationCount > 0}">
      <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.9253 11.8083L15.5628 11.5166C15.4654 11.4386 15.3867 11.3397 15.3326 11.2272C15.2785 11.1147 15.2504 10.9915 15.2503 10.8666V7.49995C15.2498 6.05315 14.7474 4.65132 13.8288 3.53359C12.9101 2.41586 11.6321 1.65146 10.2128 1.37079C10.1436 1.10237 9.98716 0.864568 9.76805 0.694784C9.54894 0.524999 9.27961 0.432861 9.00241 0.432861C8.72522 0.432861 8.45588 0.524999 8.23677 0.694784C8.01766 0.864568 7.8612 1.10237 7.79199 1.37079C6.37191 1.65061 5.09297 2.41465 4.17349 3.53246C3.25401 4.65027 2.751 6.05256 2.75033 7.49995V10.8666C2.75025 10.9915 2.72213 11.1147 2.66804 11.2272C2.61395 11.3397 2.53527 11.4386 2.43783 11.5166L2.07533 11.8083C1.63753 12.1583 1.28376 12.602 1.04003 13.1067C0.796312 13.6115 0.66884 14.1644 0.666992 14.725V15.4166C0.666992 15.8586 0.842587 16.2826 1.15515 16.5951C1.46771 16.9077 1.89163 17.0833 2.33366 17.0833H5.77533C5.96316 17.7948 6.38117 18.4242 6.96416 18.8732C7.54715 19.3223 8.26236 19.5658 8.99825 19.5658C9.73413 19.5658 10.4493 19.3223 11.0323 18.8732C11.6153 18.4242 12.0333 17.7948 12.2212 17.0833H15.667C16.109 17.0833 16.5329 16.9077 16.8455 16.5951C17.1581 16.2826 17.3337 15.8586 17.3337 15.4166V14.7333C17.3331 14.1714 17.2062 13.6168 16.9624 13.1105C16.7187 12.6042 16.3642 12.1592 15.9253 11.8083ZM9.00033 17.9166C8.70947 17.9149 8.42414 17.837 8.17269 17.6908C7.92124 17.5446 7.71242 17.3352 7.56699 17.0833H10.4378C10.292 17.3358 10.0826 17.5456 9.83033 17.6919C9.57809 17.8381 9.29189 17.9156 9.00033 17.9166ZM15.667 15.4166H2.33366V14.7333C2.3341 14.421 2.40473 14.1129 2.54032 13.8316C2.67591 13.5503 2.87299 13.3031 3.11699 13.1083L3.47949 12.8166C3.77184 12.5826 4.00786 12.2858 4.17012 11.9483C4.33239 11.6108 4.41676 11.2411 4.41699 10.8666V7.49995C4.41699 6.28438 4.89988 5.11859 5.75942 4.25905C6.61896 3.3995 7.78475 2.91662 9.00033 2.91662C10.2159 2.91662 11.3817 3.3995 12.2412 4.25905C13.1008 5.11859 13.5837 6.28438 13.5837 7.49995V10.8666C13.5833 11.2418 13.6673 11.6123 13.8296 11.9506C13.9919 12.2889 14.2283 12.5863 14.5212 12.8208L14.8837 13.1125C15.1271 13.3069 15.3239 13.5534 15.4594 13.8339C15.595 14.1144 15.6659 14.4217 15.667 14.7333V15.4166Z"
          fill="#10123D" />
      </svg>

      <span class="notification-dot" matBadge={{notifcationCount}}>
      </span>
    </button>
    <!-- <button mat-icon-button aria-label="chat" (click)="showChatModel()">
      <img src="{{chatBotImageSrc}}" matTooltip="Ask anything" class="o3ChatBot-imag" style="width:2rem">
    </button> -->
    <button mat-icon-button [matMenuTriggerFor]="menu" class="profile-btn" color="accent" [attr.aria-label]="langObj?.Profile ?? ('Profile' | translate)">
      <ngx-avatar size="50" [src]="userProfile?.picture ? userProfile?.picture : ''" [name]="userProfile?.fullName"
        [textSizeRatio]="2" [round]="true" [initialsSize]="2"></ngx-avatar>
    </button>
    <button mat-icon-button [matMenuTriggerFor]="menu1" class="profile-btn" color="black" [attr.aria-label]="langObj?.Profile ?? ('Profile' | translate)">
      <mat-icon>info</mat-icon>
      <span class="custom-badge" *ngIf="isNewRelease()">{{langObj?.NewRelease ?? ('NewRelease' | translate)}}</span>
    </button>
    <mat-menu #menu="matMenu" class="userMenu">
      <button mat-menu-item [matTooltip]="userProfile.fullName" matTooltipClass="test">
        <span style="font-weight:bold;overflow: hidden;">{{userProfile.fullName}} </span>
      </button>
      <button mat-menu-item (click)="navigateToUserProfile()">
        <span>{{langObj?.Profile ?? ('Profile' | translate)}}</span>
      </button>
      <button mat-menu-item [matTooltip]="userProfile.fullName" matTooltipClass="test" (click)="navigateToUserPlants()">
        <span>{{userProfile.fullName + 'ʼs Plants'}}</span>
      </button>
      <button mat-menu-item (click)="showResetPasswordPopup()">
        <!-- <span></span> -->
        {{langObj?.ResetPassword ?? ('ResetPassword' | translate)}}
      </button>
      <button mat-menu-item (click)="logout()">
        <span>{{langObj?.SignOut ?? ('SignOut' | translate)}}</span>
      </button>
    </mat-menu>

  </div>
</section>

<ng-template #resetPasswordDialog>
  <div class="d-flex justify-content-between align-items-center mb-5">
    <h2 style="margin-bottom:50px;">{{langObj?.ResetPassword ?? ('ResetPassword' | translate)}}</h2>
    <button mat-mini-fab mat-button mat-dialog-close color="warn" title="{{langObj?.Close ?? ('Close' | translate)}}" style="position:relative;top:-15px;">
      <i class="fa fa-times" style="color: #fff;position:relative;top:-1px;"></i>
    </button>
  </div>

  <form [formGroup]="resetPasswordForm" class="reset-form-styling">

    <mat-form-field style="margin-top: 10px;">
      <input autocomplete="off" [type]="showOldPassword ? 'text' : 'password'" matInput placeholder="{{langObj?.OldPassword ?? ('OldPassword' | translate)}}"
        type="text" formControlName="oldPassword" required>
      <i class="fa-solid show-hide-password-icons new-password" [class.fa-eye-slash]="!showOldPassword"
        [class.fa-eye]="showOldPassword" (click)="showHideOldPassword($event)"></i>
      <mat-error *ngIf="resetPasswordForm.get('oldPassword').hasError('required')">
        {{langObj?.OldPasswordIsRequired ?? ('OldPasswordIsRequired' | translate)}}
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <input autocomplete="off" [type]="showPassword ? 'text' : 'password'" matInput placeholder="{{langObj?.NewPassword ?? ('NewPassword' | translate)}}"
        type="text" formControlName="newPassword" required>
      <i class="fa-solid show-hide-password-icons new-password" [class.fa-eye-slash]="!showPassword"
        [class.fa-eye]="showPassword" (click)="showHidePassword($event)"></i>

      <!-- General error messages -->
      <mat-error *ngIf="resetPasswordForm.get('newPassword').hasError('required')">
        {{langObj?.NewPasswordIsRequired ?? ('NewPasswordIsRequired' | translate)}}
      </mat-error>
      <mat-error *ngIf="resetPasswordForm.get('newPassword').hasError('minlength')">
        {{langObj?.NewPasswordMustBeAtLeast6CharactersLong ?? ('NewPasswordMustBeAtLeast6CharactersLong' | translate)}}
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <input autocomplete="off" [type]="showConfirmPassword ? 'text' : 'password'" matInput
        placeholder="{{langObj?.ConfirmNewPassword ?? ('ConfirmNewPassword' | translate)}}" type="text" formControlName="confirmNewPassword" required>
      <i class="fa-solid show-hide-password-icons confirm-password" [class.fa-eye-slash]="!showConfirmPassword"
        [class.fa-eye]="showConfirmPassword" (click)="showHideConfirmPassword($event)"></i>
      <mat-error *ngIf="resetPasswordForm.get('confirmNewPassword').hasError('required')">
        {{langObj?.ConfirmNewPasswordIsRequired ?? ('ConfirmNewPasswordIsRequired' | translate)}}
      </mat-error>
    </mat-form-field>

    <div style="display: flex; justify-content: flex-end; ">
      <button style="margin-top:25px; right:0;cursor:pointer;" mat-mini-fab mat-button mat-dialog-close color="primary"
        (click)="resetPassword()" [disabled]="resetPasswordForm.invalid" pTooltip="{{langObj?.ResetPassword ?? ('ResetPassword' | translate)}}"
        tooltipPosition="top">
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </form>
</ng-template>
<ng-template #o3gpt>
  <div class="d-flex justify-content-between align-items-center">
    <h1 class="main-title">{{langObj?.O3Help ?? ('O3 Help' | translate)}}</h1>
    <button mat-mini-fab mat-button mat-dialog-close color="warn" title="{{langObj?.Close ?? ('Close' | translate)}}">
      <i class="fa fa-times" style="color: #fff"></i>
    </button>
  </div>
  <div class="chatbox" #scrollMe [scrollTop]="scrollMe.scrollHeight" *ngIf="chats.length > 0">
    <div *ngFor="let chat of chats" class="chat" [ngClass]="{'bot': chat.isBot, 'user': !chat.isBot}">
      <div class="user-photo">
        <img [src]="chat.isBot ? 'assets/images/O3Help.png' : 'assets/images/O3sigma_logo_blue.png'">
      </div>
      <p [ngClass]="{'chat-message-bot':chat.isBot,'chat-message':!chat.isBot}" id="chatMessages">{{ chat.message }}
        <time class="time-bot">{{ chat.time | date:'shortTime' }}</time>
      </p>
    </div>
  </div>
  <div class="img-center">
    <img *ngIf="isLoader" class="img-size" mat-card-image src="assets/images/loader-o3-help.gif"
      alt="Photo of a loader">
  </div>

  <div class="chat-form img-center">
    <textarea [(ngModel)]="userInput" placeholder="{{langObj?.TypeYourMessage ?? ('TypeYourMessage' | translate)}}" (keydown.enter)="sendMessage()"></textarea>
    <mat-icon class="icon-send" (click)="sendMessage()" matTooltip="{{langObj?.Send ?? ('Send' | translate)}}">send</mat-icon>
    <mat-icon class="icon-clear" (click)="clearMessage()" matTooltip="{{langObj?.ClearChatLogs ?? ('ClearChatLogs' | translate)}}">clear_all</mat-icon>

  </div>


</ng-template>

<mat-menu #menu1="matMenu" class="version-menu">
  <div *ngIf="versions.length === 0" class="no-data-message">
    {{langObj?.NoData ?? ('NoData' | translate)}}
  </div>
  <div *ngFor="let version of versions" class="menu-item"
    [ngClass]="{'unread': !version.Approved, 'matched-version': version.VersionNumber === versionData.version}">
    <div class="menu-item-content" (click)="openDialog(version)">
      <div class="version-details">
        <div class="version-header">
          <span class="version-tag" [ngClass]="{'new': !version.Approved}">{{langObj?.VersionNo ?? ('VersionNo' | translate)}}:</span>
          <span class="version-number">{{ version.VersionNumber }}</span>
          <div class="version-date">{{ version.CreatedDate | date:'yyyy-MM-dd' }}</div>
          <span *ngIf="version.VersionNumber === versionData.version" class="green-dot"></span>
        </div>
        <div class="description">{{ stripHtmlTags(version.Description) }}</div>
      </div>
    </div>
  </div>
</mat-menu>




<ng-template #dialogTemplate style="width: 40vw;">
  <h2 mat-dialog-title style="display: flex; justify-content: space-between; align-items: center;">
    {{langObj?.ReleaseInformation ?? ('ReleaseInformation' | translate)}}
    <button mat-icon-button mat-dialog-close class="close-button" [attr.aria-label]="langObj?.Close ?? ('Close' | translate)">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content style="width: 40vw;">
    <mat-list>
      <mat-list-item>
        <h3 matLine>{{langObj?.VersionNo ?? ('VersionNo' | translate)}}:</h3>
        <p matLine>{{ selectedVersion.VersionNumber }}</p>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <h3 matLine>{{langObj?.Date ?? ('Date' | translate)}}:</h3>
        <p matLine>{{ selectedVersion.CreatedDate | date:'yyyy-MM-dd' }}</p>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <h3 matLine>{{langObj?.Name ?? ('Name' | translate)}}:</h3>
        <p matLine>{{ selectedVersion.Name }}</p>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <h3 matLine>{{langObj?.Description ?? ('Description' | translate)}}:</h3>
        <p matLine [innerHTML]="safeHtml"></p>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item style="margin-top: 5px;">
        <div style="display: flex; gap:10px">
          <div (click)="viewPDF()" style="cursor: pointer; display: flex; align-items: center;">
            <mat-icon>picture_as_pdf</mat-icon>
            <span style="margin-left: 8px;">{{langObj?.ViewReleaseNotes ?? ('ViewReleaseNotes' | translate)}}</span>
          </div>

          <div (click)="viewManualPDF()" style="cursor: pointer; display: flex; align-items: center;">
            <mat-icon>picture_as_pdf</mat-icon>
            <span style="margin-left: 8px;">{{langObj?.ViewUserManual ?? ('ViewUserManual' | translate)}}</span>
          </div>
        </div>

      </mat-list-item>
    </mat-list>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="accent" *ngIf="!showApproveButton" (click)="onApprove()">{{langObj?.Ok ?? ('Ok' | translate)}}</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #pdfViewerTemplate>
  <h2 mat-dialog-title style="display: flex; justify-content: space-between; align-items: center;">
    {{langObj?.ViewPDF ?? ('ViewPDF' | translate)}}
    <button mat-icon-button mat-dialog-close class="close-button" [attr.aria-label]="langObj?.Close ?? ('Close' | translate)" (click)="closePDFViewer()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="downloadPDF()" style="margin-bottom: 50px;">
      {{langObj?.DownloadPDF ?? ('DownloadPDF' | translate)}}
    </button>
  </mat-dialog-actions>
  <mat-dialog-content style="width: 100%; height: 80vh;">
    <!-- <ngx-doc-viewer [url]="pdfSrc" viewer="google" style="width: 100%; height: 100%;"></ngx-doc-viewer> -->
    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner>{{langObj?.Loading ?? ('Loading' | translate)}}</mat-spinner>
    </div>
    <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false" (after-load-complete)="onPDFLoad()"
      (onError)="onPDFError()" style="width: 100%; height: 500px"></pdf-viewer>
  </mat-dialog-content>
</ng-template>

<app-notifications></app-notifications>